import { render } from "./DrugTestDashboard.vue?vue&type=template&id=e4700cc6&ts=true"
import script from "./DrugTestDashboard.vue?vue&type=script&lang=ts"
export * from "./DrugTestDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__